// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoice-person[data-v-edd94568]{font-size:14px;color:#333;margin-top:20px}.check-notice[data-v-edd94568]{text-align:center;margin-bottom:22px}", ""]);
// Exports
module.exports = exports;
